/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class LoadingIndicatorEvents {
}
LoadingIndicatorEvents.CLEAR_SHOWN_FLAG_EVENT = 'sirius.loading-indicator.shown-flag.clear';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9hZGluZy1pbmRpY2F0b3IuZXZlbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3NoYXJlZC9sb2FkaW5nLWluZGljYXRvcnMvbG9hZGluZy1pbmRpY2F0b3IuZXZlbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxPQUFPLHNCQUFzQjs7QUFDUiw2Q0FBc0IsR0FBRywyQ0FBMkMsQ0FBQyJ9